/*
 * @Author: cc
 * @Date: 2016-03-01
 * @LastEditTime: 2021-06-10 12:30:33
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\website\toBeCompiled\timingSign\editCenterCompiledTimingSign.js
 * @Description:  网站定时签发模块
 */
'use strict';
angular.module('editingCenterCompiledWebsiteTimingSignModule', [])
    .controller('editCompileWebsiteTimingSignController', [
        '$scope', 
        '$q',
        'trsHttpService', 
        '$stateParams',
        'modalDialog',
        'trsspliceString',
        'initSingleSelecet',
        'editcenterRightsService',
        'getWebsiteNameService',
        'editingCenterService',
        'globleParamsSet',
        'storageListenerService',
        'newMediaService',
        'websiteConst',
        function (
            $scope,
            $q,
            trsHttpService,
            $stateParams,
            modalDialog,
            trsspliceString,
            initSingleSelecet,
            editcenterRightsService, 
            getWebsiteNameService, 
            editingCenterService, 
            globleParamsSet, 
            storageListenerService,
            newMediaService,
            websiteConst
        ) {
            initStatus();
            initData();

            /**
             * [initStatus description] 初始化状态
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.page = {
                    'CURRPAGE': 1,
                    'PAGESIZE': globleParamsSet.getPageSize(),
                    'ITEMCOUNT': 0,
                    'PAGECOUNT': 1
                };
                $scope.params = {
                    'serviceid': 'mlf_website',
                    'methodname': 'queryTimingPublishDoc',
                    'PageSize': $scope.page.PAGESIZE,
                    'CurrPage': $scope.page.CURRPAGE,
                    'SiteId': $stateParams.siteid,
                    'timeType': '',
                    'DocId': ''
                };
                $scope.status = {
                    preview: {
                        1: 'websiteNewsPreview',
                        2: 'websiteAtlasPreview'
                    },
                    batchOperateBtn: {
                        'hoverStatus': '',
                        'clickStatus': ''
                    },
                    copyCurrPage: 1,
                    siteid: $stateParams.siteid,
                    channelid: $stateParams.channelid,
                    isESSearch: false,
                };
                $scope.data = {
                    selectedArray: []
                };
            }

            /**
             * [initData description] 初始化数据
             * @return  {[type]}  [return description]
             */
            function initData() {
                requestData();
                initDropDown();
                editcenterRightsService.initWebsiteListBtnWithoutChn('website.signtime', $stateParams.siteid).then(function (rights) {
                    $scope.status.btnRights = rights;
                });
                getWebsiteNameService.getWebsiteName($stateParams.siteid).then(function (data) {
                    $scope.data.channelName = data.SITEDESC;
                });
            }

            /**
             * [requestData description] 执行数据请求（为了掉用方法的统一）
             * @return  {[type]}  [return description]
             */
            $scope.requestData = function(){
                requestData();
            };

            /**
             * [initDropDown description]初始化各类下拉框
             * @return {[type]} [description]
             */
            function initDropDown() {
                // 初始化选择日期
                // $scope.data.timeTypeJsons = initSingleSelecet.timeType();
                // $scope.data.timeType = angular.copy($scope.data.timeTypeJsons[0]); // ne
                // 初始化选择类型
                $scope.data.docTypeJsons = initSingleSelecet.websiteDocType();
                $scope.data.docType = angular.copy($scope.data.docTypeJsons[0]);
                // 初始化搜索框边的下拉框
                $scope.data.iWoEntireJsons = initSingleSelecet.iWoEntire();
                $scope.data.iWoEntire = angular.copy($scope.data.iWoEntireJsons[0]);
                // 排序方式
                $scope.sortTypeJsons = initSingleSelecet.sortType();
                $scope.sortType = angular.copy($scope.sortTypeJsons[1]);
            }

            /**
             * [requestData description]数据请求方法
             * @return {[type]} [description]null
             */
            function requestData() {
                var params = $scope.status.isESSearch ? getESSearchParams() : $scope.params; // eee
                var deferred = $q.defer();
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    $scope.items = data.DATA;
                    !!data.PAGER ? $scope.page = data.PAGER : $scope.page.ITEMCOUNT = '0';
                    $scope.data.selectedArray = [];
                    deferred.resolve(data);
                });
                return deferred.promise;
            }
            // 全选
            $scope.selectAll = function () {
                $scope.data.selectedArray = $scope.data.selectedArray.length === $scope.items.length ? [] : [].concat($scope.items);
            };
            // 单选
            $scope.selectDoc = function (item) {
                if ($scope.data.selectedArray.indexOf(item) < 0) {
                    $scope.data.selectedArray.push(item);
                } else {
                    $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
                }
            };
            // 下一页
            $scope.pageChanged = function () {
                $scope.params.CurrPage = $scope.page.CURRPAGE;
                $scope.status.copyCurrPage = $scope.page.CURRPAGE;
                requestData();
            };
            // 跳转到
            $scope.jumpToPage = function () {
                if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                    $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
                }
                $scope.params.CurrPage = $scope.status.copyCurrPage;
                $scope.page.CURRPAGE = $scope.status.copyCurrPage;
                requestData();
            };

            /**
             * [selectPageNum description]单页选择分页条数
             * @return {[type]} [description]
             */
            $scope.selectPageNum = function () {
                $scope.params.CurrPage = $scope.page.CURRPAGE;
                $scope.params.PageSize = $scope.page.PAGESIZE;
                $scope.status.copyCurrPage = 1;
                requestData();
            };
            // 多项取消定时签发
            $scope.restoreTime = function () {
                $scope.status.isESSearch = false;
                modalDialog.confirmModal('撤销定时签发', '确认撤销定时签发', function () {
                    var arrayMetaIds = trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',');
                    var arrayChnldocIds = trsspliceString.spliceString($scope.data.selectedArray, 'CHNLDOCID', ',');
                    cancelTimeSign(arrayChnldocIds, arrayMetaIds);
                });
            };
            // 单项取消定时签发
            $scope.singleCancelTimeSign = function (item) {
                $scope.status.isESSearch = false;
                modalDialog.confirmModal('撤销定时签发', '确认撤销定时签发', function () {
                    cancelTimeSign(item.CHNLDOCID, item.METADATAID);
                });
            };

            /**
             * [changeTimeSinged description] 修改定时签发
             * @param   {[object]}  item  [item description] 稿件信息
             * @return  {[type]}          [return description]
             */
            $scope.changeTimeSinged = function (item) {
                if (!!item && !$scope.data.selectedArray.includes(item)){
                    $scope.data.selectedArray.push(item);
                }
                $scope.status.isESSearch = false;
                newMediaService.timeSign($scope, websiteConst.changeTimeSing, signCallBack);
                // timeSinged(item);
            };

            /**
             * [signCallBack description] 签发回调
             * @param   {[type]}  params  [params description]
             * @param   {[type]}  array   [array description]
             * @return  {[type]}          [return description]
             */
            function signCallBack(params, array) {
                var ChnlDocIds = [];
                var ObjectIds = [];
                var MetaDataIds = [];
                for (var i = 0; i < array.length; i++) {
                    ChnlDocIds.push(array[i].DOC.CHNLDOCID);
                    ObjectIds.push(array[i].DOC.CHNLDOCID);
                    MetaDataIds.push(array[i].DOC.METADATAID);
                }
                params.ChnlDocIds = ChnlDocIds.join(',');
                params.ObjectIds = ObjectIds.join(',');
                params.MetaDataIds = MetaDataIds.join(',');
            }

            // 只看我的开始
            $scope.isOnlyMine = function () {
                $scope.params.methodname = 'queryTimingPublishDoc';
                $scope.params.serviceid = 'mlf_website';
                $scope.params.isOnlyMine = true;
                $scope.onlyMine = !$scope.onlyMine;
                if (!$scope.onlyMine) {
                    delete $scope.params.isOnlyMine;
                }
                requestData();
            };
            // 只看我的结束
            /**
             * [cancelTimeSign description] 取消定时签发
             * @param   {[type]}  ChnlDocIds   [ChnlDocIds description]
             * @param   {[type]}  MetaDataIds  [MetaDataIds description]
             * @return  {[type]}               [return description]
             */
            function cancelTimeSign(ChnlDocIds, MetaDataIds) {
                var params = {
                    serviceid: 'mlf_websiteoper',
                    methodname: 'webRepealTimingPublish',
                    ObjectIds: ChnlDocIds,
                    ChnlDocIds: ChnlDocIds,
                    MetaDataIds: MetaDataIds,
                    ScheduleTime: ''
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    requestData();
                });
            }
    

            /**
             * [queryByDropdown description]根据类型查询稿件
             * @param  {[str]} type  [description]查询类型
             * @param  {[str]} value [description]查询参数
             * @return {[type]}       [description]null
             */
            $scope.queryByDropdown = function (type, value) {
                $scope.params[type] = value;
                $scope.status.copyCurrPage = $scope.page.CURRPAGE = $scope.params.CurrPage = 1;
                if (type === 'timeType') {
                    $scope.params.OperTimeStart = $scope.data.fromdate;
                    $scope.params.OperTimeEnd = $scope.data.untildate;
                    $scope.params[type] = null;
                }
                requestData();
            };

            /**
         * [showVersionTime description]展示流程版本与操作日志
         * @param  {[str]} item        [description]
         * @return {[type]}            [description]
         */
            $scope.showVersionTime = function (item) {
                editingCenterService.getVersionTime(item, false);
            };

            /**
         * [getESSearchParams description]
         * @return  {[type]}  [return description]
         */
            function getESSearchParams() {
                var esParams = {
                    serviceid: 'mlf_hybasesearch',
                    methodname: 'queryForWebSiteTimingPublishDoc',
                    searchParams: {
                        PAGESIZE: $scope.page.PAGESIZE + '',
                        PAGEINDEX: $scope.page.CURRPAGE + '',
                        searchFields: [{
                            searchField: $scope.data.iWoEntire.value,
                            keywords: $scope.keywords ? $scope.keywords : ''
                        }, {
                            searchField: 'docType',
                            keywords: $scope.data.docType.value
                        }, {
                            searchField: 'timeType',
                            keywords: (angular.isDefined($scope.data.fromdate) && $scope.data.fromdate !== '') ? $scope.data.fromdate + ',' + $scope.data.untildate : $scope.data.timeType.value
                        }, {
                            searchField: 'isOnlyMine',
                            keywords: angular.isDefined($scope.onlyMine) ? $scope.onlyMine : ''
                        }, {
                            searchField: 'siteid',
                            keywords: $stateParams.siteid
                        }, {
                            searchField: '_sort',
                            keywords: $scope.sortType.value
                        }]
                    }
                };
                esParams.searchParams = JSON.stringify(esParams.searchParams);
                return esParams;
            }
            // 搜索
            $scope.fullTextSearch = function (ev) {
                if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                    if ($scope.data.iWoEntire.value === 'DocID') {
                        $scope.status.isESSearch = false;
                        $scope.params.DocId = $scope.keywords;
                    } else {
                        $scope.status.isESSearch = true;
                    }
                    $scope.page.CURRPAGE = 1;
                    requestData();
                }
            };

            /**
         * [websitePreview description] 预览页
         * @return {[type]}      [description]
         */
            $scope.websitePreview = function () {
                storageListenerService.previewPageTurningStorage($scope.items, 'METADATAID,CHNLDOCID,DOCTYPEID,CHANNELID', 'websitePreview');
            };
        }]);
